import React from 'react'
import { injectIpsos } from '../../tracking'
import { AmpAnalytics } from '../analytics'

export interface AmpIpsosProps {
    pathName: string
    hostName: string
}

export const AmpIpsos: React.FC<AmpIpsosProps> = ({ pathName, hostName }) => {
    return (
        <AmpAnalytics
            config={injectIpsos(hostName, pathName, 'amp') || ''}
        ></AmpAnalytics>
    )
}
